import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { CompanyQueryData } from '@area-restrita/api-client/model/companyQueryData';

interface CompanySelectorState {
  selectedCompany: CompanyQueryData | null;
  selectCompany: (company: CompanyQueryData | null) => void;
}

export const useCompanySelectorStore = create(
  persist<CompanySelectorState>(
    (set) => ({
      selectedCompany: null,
      selectCompany: (company) =>
        set({
          selectedCompany: company,
        }),
    }),
    {
      name: 'companySelectorStore',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
